/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".country-grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(4,1fr);border-left:1px solid #e0e0e0;border-top:1px solid #e0e0e0}.country-item[_ngcontent-%COMP%]{padding:14px 20px;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;font-size:17px;color:#333}@media (max-width:768px){.country-grid[_ngcontent-%COMP%]{grid-template-columns:repeat(2,1fr)}}"];
export { styles as styles };
